// 📁 src/components/GlobalHeader.js
import React from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api";
import socket from "../socket";

export default function GlobalHeader({ isAuthenticated, setAuthenticated }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    let saved = false;

    // Try to save last known location (non-blocking)
    if (navigator.geolocation) {
      await new Promise((resolve) => {
        navigator.geolocation.getCurrentPosition(
          async (pos) => {
            try {
              await axios.post(
                "/api/save-last-location",
                {
                  lat: pos.coords.latitude,
                  lng: pos.coords.longitude,
                },
                { withCredentials: true }
              );
              saved = true;
            } catch (e) {
              console.warn("Saving last location failed:", e);
            }
            resolve();
          },
          (err) => {
            console.warn("Could not get location on logout:", err);
            resolve();
          },
          {
            enableHighAccuracy: false,
            timeout: 1500,     // 🔥 Short timeout so logout never hangs
            maximumAge: 10000, // Allow cached location if available
          }
        );
      });
    }

    // Proceed with logout regardless of GPS success
    await doLogout();
  };

const doLogout = async () => {
  try {
    await axios.post("/api/logout", {}, { withCredentials: true });
  } catch (err) {
    console.error("Logout request failed:", err);
  } finally {
    // 🔥 FORCE SOCKET DISCONNECT
    socket.disconnect();

    setAuthenticated(false);
    navigate("/login");
  }
};


  return (
    <header
      style={{
        width: "100%",
        padding: "12px 20px",
        background: "#222",
        color: "white",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        boxSizing: "border-box",
        zIndex: 100,
      }}
    >
      <h1 style={{ margin: 0, fontSize: "20px", fontWeight: "600" }}>
        🎮 GPS Game
      </h1>

      {isAuthenticated && (
        <button
          onClick={handleLogout}
          style={{
            background: "#e53935",
            border: "none",
            padding: "8px 14px",
            borderRadius: "5px",
            color: "white",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          Logout
        </button>
      )}
    </header>
  );
}
